import { createClient } from "@supabase/supabase-js";

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl) {
  throw new Error("Missing VITE_SUPABASE_URL");
}

if (!supabaseAnonKey) {
  throw new Error("Missing VITE_SUPABASE_ANON_KEY");
}

const globalForSupabase = globalThis;

if (!globalForSupabase.__ANNOOR_SUPABASE_CLIENT__) {
  globalForSupabase.__ANNOOR_SUPABASE_CLIENT__ = createClient(
    supabaseUrl,
    supabaseAnonKey,
    {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: "annoor-supabase-auth-token",
      },
    }
  );
}

export const supabase = globalForSupabase.__ANNOOR_SUPABASE_CLIENT__;

export async function getSupabase() {
  return supabase;
}